export default "__VITE_ASSET__BwwjsgU7__"